import React from 'react';
import CityManagementPanel from '../../components/admin/CityManagementPanel';

const CityManagementPage: React.FC = () => {
  return (
    <div>
      <CityManagementPanel />
    </div>
  );
};

export default CityManagementPage;
